var localNames = {"wt-select-wrapper__error-message":"_wt-select-wrapper__error-message_clqd2","wt-select-wrapper__note":"_wt-select-wrapper__note_sgtcc"};

export { localNames as default };
